import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import { DatePicker, TimePicker, TimePickerProps } from "antd";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import TextField from '../../../../core/common/textFields/TextField';
import { customStyles } from '../../../../core/common/Custom Style/CustomStyle';
import { useCreateAppointmentMutation, useGetAllActiveUsersQuery, useGetDefaultlookupsQuery } from '../../../../services/EndPointsApis';

const AppointmentContactWizard = ({ formik, getdefaultLookups }: any) => {

    dayjs.extend(customParseFormat);
    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('startTime', formattedTime);
    };

    //active users Lookups
    const { data: getallActiveUsers, refetch: activeUsersRefetch } = useGetAllActiveUsersQuery('');

    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

    const handleAptDateChange = (date: Dayjs | null) => {
        formik?.setFieldValue('startDate', date ? date.format('YYYY-MM-DD') : null);
    };


    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <h5 className='text-gray mb-3'>Appointments</h5>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        1st Appointment Date <span className="text-danger">*</span>
                    </label>
                    <div className="form-wrap icon-form">
                        <span className="form-icon">
                            <i className="ti ti-calendar-check" />
                        </span>
                        <DatePicker
                            className="form-control datetimepicker deals-details"
                            onChange={handleAptDateChange}
                            value={formik?.values?.startDate ? dayjs(formik?.values?.startDate, 'YYYY-MM-DD') : null}
                            format="MMM-DD-YYYY"
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        Time <span className="text-danger">*</span>
                    </label>
                    <TimePicker
                        placeholder="Select Time"
                        className="form-control datetimepicker-time"
                        {...formik.getFieldProps('startTime')}
                        onChange={onChangeStart}
                        defaultOpenValue={dayjs("00:00 AM", "h:mm A")}
                        format="h:mm A"
                        use12Hours
                        // Check if startTime exists and is a valid format before passing it to dayjs
                        value={formik.values?.startTime && dayjs(formik.values.startTime, "h:mm A").isValid()
                            ? dayjs(formik.values.startTime, "h:mm A")
                            : null}
                    />
                </div>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        Appointment Maker <span className="text-danger"> *</span>
                    </label>
                    <Select
                        styles={customStyles}
                        className="select"
                        options={getallActiveUsers?.result?.
                            map((option: any) => ({
                                label: option?.userName,
                                value: option?.userId
                            }))}
                        value={
                            formik.values?.internalAttendees[0]?.id
                                ? {
                                    value: formik.values?.internalAttendees[0]?.id,
                                    label: formik.values?.internalAttendees[0]?.value || '',
                                }
                                : null
                        }
                        // isDisabled={isReadOnly}
                        onChange={(selectedOption: any) => {
                            formik.setFieldValue('internalAttendees[0].id', selectedOption.value);
                            formik.setFieldValue('internalAttendees[0].value', selectedOption.label);
                        }}
                    />
                </div>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        1st Appointment Location<span className="text-danger"> *</span>
                    </label>
                    <Select
                        styles={customStyles}
                        className="select"
                        options={
                            getdefaultLookups?.result?.Lst_FreshAptLocation?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                        value={
                            formik.values?.lst_FreshAptLocation?.id
                                ? {
                                    value: formik.values?.lst_FreshAptLocation?.id,
                                    label: formik.values?.lst_FreshAptLocation?.value || '',
                                }
                                : null
                        }
                        // isDisabled={isReadOnly}
                        onChange={(selectedOption: any) => {
                            formik.setFieldValue('lst_FreshAptLocation.id', selectedOption.value);
                            formik.setFieldValue('lst_FreshAptLocation.value', selectedOption.label);
                        }}
                    />
                </div>
            </div>
        </form>
    )
}

export default AppointmentContactWizard